import { IMiseAJourExamenWebServiceClient, MiseAJourDto } from "@resources/resources";
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { CorrespondantStore } from "@digicerba/common";


@Injectable()
export class MisesAJourResolver implements Resolve<Array<MiseAJourDto>> {

  constructor(private misesAJourExamenWebService: IMiseAJourExamenWebServiceClient,
              private correspondantStore: CorrespondantStore) {
  }

  resolve() {
    // Si on n'a pas le tag permettant d'accéder à la partie modification
    // alors on est redirigé vers l'accueil de l'app
    // Rq: avant j'avais fait une guard mais le pb est que les guards
    // sont exécutées avant les resolvers donc on n'avait pas encore récupéré
    // le correspondant via le cookie. Ici au moins on l'a.
    if (!this.correspondantStore.hasTag("majcatalogue")) {
      window.location.href = window.location.origin;
    }

    return this.misesAJourExamenWebService.misesAJour();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/misesAjour.resolver.ts